import { Card as SkedCard } from '@screentone/addon-sked';
import { Wrapper } from '@screentone/core';

// eslint-disable-next-line import/no-cycle -- TODO: pre-existing cycle via DataModelContext, fix when context is restructured
import { RemoveEntity } from 'components/context-menu-actions/remove-entity/RemoveEntity';
import styles from './CancelledEmbargoArticle.module.scss';

interface CancelledEmbargoArticleProps {
  allessehId: string;
  hierarchyId: string;
  isDraft?: boolean;
  isCollectionItem?: boolean;
}

export const CancelledEmbargoArticle = ({
  allessehId,
  hierarchyId,
  isDraft,
  isCollectionItem = false
}: CancelledEmbargoArticleProps) => {
  const removeEntityText = isCollectionItem ? 'Remove from collection' : 'Remove from module';
  return (
    <div
      data-model-hierarchy-id={hierarchyId}
      data-allesseh-id={allessehId}
      className={styles.cardContainer}
      data-testid="page-content-card-container"
    >
      <SkedCard>
        <SkedCard.Header
          slug="Card no longer available"
          menu={
            isDraft ? (
              <Wrapper padding={{ all: 'smd' }}>
                <RemoveEntity hierarchyId={hierarchyId} text={removeEntityText} />
              </Wrapper>
            ) : undefined
          }
        />
        <SkedCard.Content
          type="curation"
          headline={`The embargo was cancelled. ID: ${allessehId}`}
          testIds={{ headline: 'cancelled-embargo-headline' }}
        />
      </SkedCard>
    </div>
  );
};
